import { Skeleton, Row, Col, Select, DatePicker } from 'antd';
import { Form, FormItem, Input, Toggle } from 'asumsi-components';
import React from 'react';
import { IResponseTag } from '@interfaces/iresponse-tag';
import { IResponseTopics } from '@interfaces/iresponse-topics';
import moment from "moment";
import { IResponseMasterUser } from '@interfaces/iresponse-user';
import slugify from "limax"


export const PageSettingPostFormComponent = (props: any) => {
    const { Option } = Select;
    // declare action and attribute needed

    const { tags, topics, isLoader, setFieldsValues, fieldsValues, setAuthorsInput, setTagsInput, authors } = props;

    const authorsChange = (value: string[]) => {
        setAuthorsInput(value);
    }

    const slugChange = (e: any) => {
        let val: string = (e.target.value).toLowerCase();
        if(val.includes("http")){
            let splitWord = val.split("/");
            let lastWord = splitWord[splitWord.length-1];
            if(!lastWord){
                lastWord = splitWord[splitWord.length-2];
            }
            val = lastWord;
        }
        let cleanSlug: string = slugify(val);

        e.target.value = cleanSlug;
    }


    const tagsChange = (value: string[]) => {
        setTagsInput(value);
    }

    const changePublishDate = (value: any) => {
        setFieldsValues({ ...fieldsValues, publishDateTime: value ? value.format() : null });
    }

    const topicChange = (value: string) => {
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'topicId');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }
        setFieldsValues({ ...fieldsValues, topicId: value, errors: [] });
    }

    const optionTags = tags ? tags.map((tag: IResponseTag) => <Option key={tag.id} value={tag.name}>{tag.name}</Option>) : [];
    const optionTopics = topics ? topics.map((topic: IResponseTopics) => <Option key={topic.id} value={topic.id}>{topic.name}</Option>) : [];
    const optionAuthors = authors ? authors.map((author: IResponseMasterUser) => {
        const value: any = {
            userId: author.userId,
            firstName: author.firstName,
            lastName: author.lastName,
            userEmail: author.email
        }
        return <Option key={JSON.stringify(value)} value={JSON.stringify(value)}>{`${author.firstName} ${author.lastName ?? ""}`}</Option>
    }) : [];

    // return JSX Element 
    return (
        <div>
            <Form titleBold={true}>
                <Skeleton loading={isLoader}>
                    <Row gutter={30}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <Row>
                                <Col span={24}>
                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Post Url" labelAlign="left"
                                        fieldDecorator={{
                                            label: "slug",
                                            rules: [{
                                                message: 'Please input slug',
                                                required: true,
                                            }
                                            ]
                                        }}
                                    >
                                        <Input id="slug" defaultValue={fieldsValues.slug} onChange={slugChange} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Excerpt" labelAlign="left"
                                        fieldDecorator={{
                                            label: "excerpt"
                                        }}
                                    >
                                        <textarea className="asumsi-input" style={{ height: "98px" }} id="excerpt" defaultValue={fieldsValues.excerpt} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Authors" labelAlign="left"
                                        fieldDecorator={{
                                            label: "authors"
                                        }}
                                    >
                                        <Select optionFilterProp="children" defaultValue={fieldsValues.authors} style={{ width: "100%" }} mode="multiple" tokenSeparators={[',']} onChange={authorsChange}>
                                            {optionAuthors}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Tags" labelAlign="left"
                                        fieldDecorator={{
                                            label: "tags"
                                        }}
                                    >
                                        <Select style={{ width: "100%" }} defaultValue={fieldsValues.tags} mode="tags" tokenSeparators={[',']} onChange={tagsChange}>
                                            {optionTags}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Published" labelAlign="left"
                                        fieldDecorator={{
                                            label: "status"
                                        }}
                                    >
                                        <Toggle id="status" defaultChecked={fieldsValues.status} />
                                    </FormItem>
                                </Col>
                                <Col span={7}>
                                    <FormItem setFieldsValues={setFieldsValues}  fieldsValues={fieldsValues} label="Topic" labelAlign="left" 
                                        fieldDecorator={{
                                            label: "topicId",
                                            rules: [{
                                                message: 'Please select topic',
                                                required: true,
                                            }
                                            ]
                                        }}
                                    >
                                        <Select id="topicId" showSearch defaultValue={fieldsValues.topicId} style={{ width: "100%" }} onChange={topicChange} value={fieldsValues.topicId} allowClear={false} >
                                            {optionTopics}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style={{ display: fieldsValues.status ? 'block' : 'none' }}>
                                <Col span={12}>
                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Publish Date" labelAlign="left"
                                        fieldDecorator={{
                                            label: "publishDateTime"
                                        }}
                                    >
                                        <DatePicker defaultValue={fieldsValues.publishDateTime ? moment(fieldsValues.publishDateTime) : null} showTime={true} onChange={changePublishDate} id="publishDateTime" format="DD MMM YYYY HH:mm:ss" />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Skeleton>
            </Form>
        </div>
    );
};
export default PageSettingPostFormComponent;



// WEBPACK FOOTER //
// ./src/pages/post-form/libraries/settings.tsx